/**
 * Layout Component
 * Main layout wrapper with header and navigation
 */

import React, { type ReactNode } from 'react';
import { Navigation } from './Navigation';

interface LayoutProps {
  children: ReactNode;
  showNavigation?: boolean;
}

export const Layout: React.FC<LayoutProps> = ({ children, showNavigation = true }) => {
  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <div style={styles.headerContent}>
          <h1 style={styles.title}>سوتک</h1>
          <p style={styles.subtitle}>سرویس رونویسی صوتی</p>
        </div>
      </header>
      
      <main style={styles.main}>
        {children}
      </main>
      
      {showNavigation && <Navigation />}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f5f5f5',
  },
  header: {
    backgroundColor: '#ffffff',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
  headerContent: {
    maxWidth: '768px',
    margin: '0 auto',
    padding: '1rem',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#1a1a1a',
    margin: 0,
  },
  subtitle: {
    fontSize: '0.875rem',
    color: '#666',
    margin: '0.25rem 0 0 0',
  },
  main: {
    flex: 1,
    maxWidth: '768px',
    width: '100%',
    margin: '0 auto',
    padding: '1rem',
    paddingBottom: '5rem', // Space for bottom navigation
  },
};
